<template>
  <div>
    <v-layout justify-space-around align-end>
      <v-flex v-if="team_1" xs4 sm4 md4 lg4>
        <h5>1st</h5>
        <team-shield :avatarSize="40" :avatar="team_1? team_1.team_logo : null"></team-shield>
        <h5>{{team_1.champ_team_name}}</h5>
      </v-flex>

      <v-flex v-if="team_2" xs4 sm4 md4 lg4 justify-center>
        <h5>2nd</h5>
        <team-shield :avatarSize="25" :avatar="team_2? team_2.team_logo : null"></team-shield>
        <h5>{{team_2.champ_team_name}}</h5>
      </v-flex>

      <v-flex v-if="team_3" xs4 sm4 md4 lg4>
        <h5>3rd</h5>
        <team-shield :avatarSize="20" :avatar="team_3? team_3.team_logo : null"></team-shield>
        <h5>{{team_3.champ_team_name}}</h5>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  props: ["team_1", "team_2", "team_3"],
  components: {
    TeamShield: () => import("@/components/Teams/TeamShield.vue")
  }
};
</script>